
import { Vue, Component, Prop } from 'vue-property-decorator'
import {
  ChannelType,
  IChannel,
  INotificationTrigger
} from '@/modules/notification-center/event-trigger/types/triggerTypes'
import PreviewLabelValue from '@/stories/preview-label-value/PreviewLabelValue.vue'
import SMSPreviewComponent from '@/modules/notification-center/event-trigger/components/preview/SMSPreviewComponent.vue'
import EmailPreviewComponent from '@/modules/notification-center/event-trigger/components/preview/EmailPreviewComponent.vue'
import TriggerVariableCard from '@/modules/notification-center/event-trigger/components/TriggerVariablesCard.vue'

@Component({
  name: 'TriggerCustomPreview',
  components: {
    PreviewLabelValue,
    SMSPreviewComponent,
    EmailPreviewComponent,
    TriggerVariableCard
  }
})
export default class TriggerCustomPreview extends Vue {
  @Prop({ type: Object, required: true })
  readonly trigger!: INotificationTrigger

  @Prop({ type: Boolean, required: false, default: false })
  readonly loading!: boolean

  channel = ''

  formatVariable(variable: string): string {
    return `{{ ${variable} }}`
  }

  formatChannels(channels: IChannel[] | string[]): string[] {
    if (!channels || !channels.length) return []
    return channels.map((channel: IChannel | string) =>
      typeof channel === 'string' ? channel : channel.name
    )
  }

  // Map channel name (type) to the corresponding preview component
  // NOTE: for now just SMS is different that's why I have created only two preview component
  get channelToComponentMapper(): Record<ChannelType, unknown> {
    return {
      SMS: SMSPreviewComponent,
      Email: EmailPreviewComponent,
      Push: EmailPreviewComponent,
      InApp: EmailPreviewComponent,
      WhatsApp: SMSPreviewComponent
    }
  }
}
